/**
 * ValueBullets - Four value propositions displayed as animated cards
 *
 * Shows the key differentiators of RigCraft:
 * 1. Song-based guidance
 * 2. Structured signal chains
 * 3. Fewer iterations, less guessing
 * 4. Built for Quad Cortex
 *
 * All cards use GlowCard with pink variant for visual consistency.
 */

"use client";

import { useTranslations } from "next-intl";
import { Music, Layers, Target, Cpu } from "lucide-react";
import { ScrollReveal, GlowCard } from "./effects";

const icons = [Music, Layers, Target, Cpu];

export default function ValueBullets() {
  const t = useTranslations("landing.value");

  const bullets = [
    { key: "songBased", icon: icons[0] },
    { key: "structured", icon: icons[1] },
    { key: "fewerIterations", icon: icons[2] },
    { key: "quadCortex", icon: icons[3] },
  ];

  return (
    <section className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {bullets.map((bullet, index) => {
            const Icon = bullet.icon;
            return (
              <ScrollReveal key={bullet.key} delay={index * 0.1}>
                <GlowCard variant="pink" className="h-full">
                  <div className="flex flex-col items-center text-center p-6">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-pink-500/20 to-purple-500/20 flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-pink-400" />
                    </div>
                    <h3 className="text-white font-semibold text-lg mb-2">
                      {t(`${bullet.key}.title`)}
                    </h3>
                    <p className="text-gray-400 text-sm">
                      {t(`${bullet.key}.description`)}
                    </p>
                  </div>
                </GlowCard>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
